import React from 'react'
import { Link, useLocation } from 'react-router-dom';
import { Row, Col } from 'antd';
import { NextArrow } from './icons';
import "./footerStyle.scss";
import { StoreImages } from '../../Storeimgaes/StoreImages';
import {useSelector} from "react-redux";

// import { IoArrowForwardOutline } from "react-icons/io5";

export default function Footer() {

  const { data } = useSelector((state) => state?.user);
  const isLoggedIn = data && Object.keys(data).length > 0;

  const location = useLocation();
  const {InkAgentLogo} = StoreImages;

  return (
    <footer className='footer-outer'>
      <div className='container'>
        <Row className='align-items-center' align="middle">
          <Col xs={24} sm={4} md={5}>
            <Link to=''>
            <img src={InkAgentLogo} alt="Logo" className='footer_logo'/>
              {/* <img src="assets/images/inkagent-logo.png" alt='Logo' /> */}
            </Link>
          </Col>
          <Col xs={24} sm={14} md={12} className='text-center'>
            <div className='footer-menu'>
              {/*<Link to='/services' className={location.pathname === '/services' ? 'active' : ''}>*/}
              {/*  Services*/}
              {/*</Link>*/}
              <Link to='/pricing-agent' className={location.pathname === '/pricing' ? 'active' : ''}>
                Pricing
              </Link>
              <Link to='/faq' className={location.pathname === '/faq' ? 'active' : ''}>
                FAQ
              </Link>
              <Link to='/resources' className={location.pathname === '/resources' ? 'active' : ''}>
                Resources
              </Link>
              <Link to='/support' className={location.pathname === '/support' ? 'active' : ''}>
                Support
              </Link>
              <Link to='/terms-conditions' className={location.pathname === '/terms-conditions' ? 'active' : ''}>
                Terms & Conditions
              </Link>
              <Link to='/privacy-policy' className={location.pathname === '/privacy-policy' ? 'active' : ''}>
                Privacy Policy
              </Link>
            </div>
          </Col>
          <Col xs={24} sm={4} md={7} className='text-right'>
            <Link to={isLoggedIn ? '/my-account' : '/login'} className={location.pathname === (isLoggedIn ? '/my-account' : '/login') ? 'active' : ''}>
              {isLoggedIn ? 'My Account' : 'Login'}
            </Link>
            <Link to={isLoggedIn ? '/logout' : '/register'} className='custom-btn theme-button'>
        <span className='d-flex align-items-center justify-content-between w-100'>
          {isLoggedIn ? 'Sign Out' : 'Sign Up'}
        </span>
              <span className='icon-circle'>
          <NextArrow />
        </span>
            </Link>
          </Col>
        </Row>

        <div>
          <div className='text-center privacy-text'>
            <p className='p-style'>
              info@inkagent.ai | © InkAgent, {new Date().getFullYear()}
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}